/*
    User profile Page
*/

import React from 'react'

import ProfileContainer from 'containers/profile/ProfileContainer'

const ProfilePage = () => <ProfileContainer />

export default ProfilePage
